import { createSlice } from "@reduxjs/toolkit";

// ---- import from local actions ----
import { fetchControlDeviceList } from "./../actions/ControlDeviceActions";


const ControlDeviceSlice = createSlice({
    name: "controlDevice",
    initialState: {
        controlDeviceList: {
          data: [],
          status: 'idle',
          error: "",
          loading: false,
      },
    },
    
    extraReducers: (builder) => {
      builder
        .addCase(fetchControlDeviceList.pending, (state) => {
          state.controlDeviceList.status = 'loading';
        })
        .addCase(fetchControlDeviceList.fulfilled, (state, action) => {
            state.controlDeviceList.status = 'idle';
            state.controlDeviceList.data = action.payload.result;
        })
        .addCase(fetchControlDeviceList.rejected, (state, action) => {
          state.controlDeviceList.status = 'rejected';
          state.controlDeviceList.error = action.error.message;
        })
    },
});


export default ControlDeviceSlice.reducer;
